/**
 * @generated SignedSource<<207d23da6c082515daf8a468d91d7eb4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesEditorSettingsMenu_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesEditorSettingsMenuCatering_data">;
  readonly " $fragmentType": "RoomRatesEditorSettingsMenu_data";
};
export type RoomRatesEditorSettingsMenu_data$key = {
  readonly " $data"?: RoomRatesEditorSettingsMenu_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesEditorSettingsMenu_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesEditorSettingsMenu_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomRatesEditorSettingsMenuCatering_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "d76f621e6e795d7e7d94e3ea894d2697";

export default node;
